import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { userPrivacy, userPrivacyConfig } from '@blade-sxp/account/api/setting';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
let default_1 = class extends Vue {
    privacyMode = false;
    fullSkDialogVisible = false;
    postUserPrivacyConfig() {
        userPrivacyConfig({
            externalBizFrom: '',
            privacy: !this.privacyMode,
        })
            .then((res) => {
            this.fullSkDialogVisible = false;
            this.getUserPrivacy();
            this.$message({ message: this.$t('common.operationSuccess').toString(), type: 'success' });
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    handlePrivacyMode() {
        this.fullSkDialogVisible = true;
    }
    getUserPrivacy() {
        userPrivacy()
            .then((res) => {
            this.privacyMode = res.data.data;
            if (this.privacyMode) {
                localStorage.setItem('privacyMode', 'true');
            }
            else {
                localStorage.setItem('privacyMode', 'false');
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    init() {
        this.getUserPrivacy();
    }
    mounted() {
        this.init();
    }
};
default_1 = __decorate([
    Component({
        name: 'privacyMode',
        components: { SecondaryVerification },
        i18n: {
            messages: {
                'en-us': {
                    privacy: 'Privacy Mode:',
                    activated: 'Activated',
                    closed: 'Closed',
                },
                zh: {
                    privacy: '隐私模式：',
                    activated: '开启',
                    closed: '关闭',
                },
            },
        },
    })
], default_1);
export default default_1;
